const target = document.querySelectorAll('.plan-chart__header');

target.forEach(e => {
    e.addEventListener('click', () => {
        const planChartDetail = e.nextElementSibling;

        if(getComputedStyle(planChartDetail).height == '0px') {
            const chartHeight = () => {
                const items = planChartDetail.children;
                const itemsCount = planChartDetail.childElementCount;
                let itemsHeight = 0;
                for(let i=0;i<itemsCount;i++) {
                    const itemHeight = () => {
                        const clientHeight = items[i].clientHeight;
                        const marginBottom = () => {
                            var number = parseInt(getComputedStyle(items[i]).marginBottom, 10);
                            return number;
                        }

                        return clientHeight + marginBottom();
                    }

                    itemsHeight = itemsHeight + itemHeight();
                }

                return itemsHeight;
            }

            planChartDetail.style.height = `${chartHeight()}px`
        } else {
            planChartDetail.style.height = 0;
        }
    });
});